import { googleLogout } from "@react-oauth/google";
import { logoutCreate } from "../api-client/logout/logout";
import { signOutOfNativeGoogle } from "./useGoogleAuth";

export default function useLogout() {

  return async () => {
    googleLogout();
    await signOutOfNativeGoogle();

    try {
      if (typeof localStorage?.clear === "function") {
        localStorage.clear();
      }
    } catch {
      // ignore storage errors
    }

    try {
      await logoutCreate();
    } catch (error) {
      // log but continue logout flow
      console.error("Error during logout:", error);
    }

    // The full page load drops the TanStack Query cache. Don't queryClient.clear() first: that
    // re-renders mounted components with no user (NewHeader reads user.isAdmin) before unload.
    window.location.pathname = "/login";
  };
}
